import { render, staticRenderFns } from "./HSSOrderDetail.vue?vue&type=template&id=6f13a5b0&scoped=true&"
import script from "./HSSOrderDetail.vue?vue&type=script&lang=js&"
export * from "./HSSOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./HSSOrderDetail.vue?vue&type=style&index=0&id=6f13a5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13a5b0",
  null
  
)

export default component.exports